export default __webpack_public_path__ + "static/media/tunasushi.edecf67e.PNG";